<div class="step-container" [id]="stepId" [class.active]="isActive" [class.completed]="isCompleted">
  <div class="step-header">
    <span class="step-badge" *ngIf="stepNumber">
      <i class="fas fa-check" *ngIf="isCompleted && !isActive; else numberTpl"></i>
      <ng-template #numberTpl>{{ stepNumber }}</ng-template>
    </span>
    <div class="step-heading">
      <h3 class="step-title" [title]="title">{{ title }}</h3>
      <p *ngIf="stepDescription" class="step-description">{{ stepDescription }}</p>
    </div>
  </div>
  <div class="step-content">
    <ng-content></ng-content>
  </div>
</div>
